// This file is generated by next-core EcmascriptClientReferenceModule.
const { createClientModuleProxy } = require("react-server-dom-turbopack/server");

__turbopack_context__.n(createClientModuleProxy("[project]/Documents/00 A Projets/CLAUDE AI/INTEGRAL PHARMA/BILAN DE PREVENTION - PLATEFORME/node_modules/next/dist/esm/client/components/http-access-fallback/error-boundary.js <module evaluation>"));
